import { render, staticRenderFns } from "./CmgRecentAndFavoriteOrdersMini.vue?vue&type=template&id=6533c022&scoped=true&lang=pug&"
import script from "./cmg-recent-and-favorite-orders-mini.ts?vue&type=script&lang=ts&"
export * from "./cmg-recent-and-favorite-orders-mini.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRecentAndFavoriteOrdersMini.vue?vue&type=style&index=0&id=6533c022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6533c022",
  null
  
)

export default component.exports